import { createReducer } from "reduxsauce";

import importer from "common/importer";

const { INITIAL_STATE } = importer("Stores/Donors/InitialState", null);
const { DonorTypes } = importer("Stores/Donors/Actions", null);

const getAllDonorsLoading = (state) => ({
  ...state,
  getAllDonorsLoading: true,
  getAllDonorsSuccess: null,
  getAllDonorsFailure: null,
});

const getAllDonorsSuccess = (state, { res }) => ({
  ...state,
  donors: res,
  getAllDonorsLoading: false,
  getAllDonorsSuccess: res,
  getAllDonorsFailure: null,
});

const getAllDonorsFailure = (state, { error }) => ({
  ...state,
  getAllDonorsLoading: false,
  getAllDonorsSuccess: null,
  getAllDonorsFailure: error,
});

const getDonorsLoading = (state) => ({
  ...state,
  getDonorsLoading: true,
  getDonorsSuccess: null,
  getDonorsFailure: null,
});

const getDonorsSuccess = (state, { res }) => ({
  ...state,
  donors: res,
  getDonorsLoading: false,
  getDonorsSuccess: res,
  getDonorsFailure: null,
});

const getDonorsFailure = (state, { error }) => ({
  ...state,
  getDonorsLoading: false,
  getDonorsSuccess: null,
  getDonorsFailure: error,
});

const getDonorBySfidLoading = (state) => ({
  ...state,
  getDonorBySfidLoading: true,
  getDonorBySfidSuccess: null,
  getDonorBySfidFailure: null,
});

const getDonorBySfidSuccess = (state, { res }) => ({
  ...state,
  getDonorBySfidLoading: false,
  getDonorBySfidSuccess: res,
  getDonorBySfidFailure: null,
});

const getDonorBySfidFailure = (state, { error }) => ({
  ...state,
  getDonorBySfidLoading: false,
  getDonorBySfidSuccess: null,
  getDonorBySfidFailure: error,
});

const searchForDonorLoading = (state) => ({
  ...state,
  searchForDonorLoading: true,
  searchForDonorSuccess: null,
  searchForDonorFailure: null,
});

const searchForDonorSuccess = (state, { res }) => ({
  ...state,
  searchForDonorLoading: false,
  searchForDonorSuccess: res,
  searchForDonorFailure: null,
});

const searchForDonorFailure = (state, { error }) => ({
  ...state,
  searchForDonorLoading: false,
  searchForDonorSuccess: null,
  searchForDonorFailure: error,
});

const searchActiveDonorsLoading = (state) => ({
  ...state,
  searchActiveDonorsLoading: true,
  searchActiveDonorsSuccess: null,
  searchActiveDonorsFailure: null,
});
const searchActiveDonorsSuccess = (state, { res }) => ({
  ...state,
  searchActiveDonorsLoading: false,
  searchActiveDonorsSuccess: res,
  searchActiveDonorsFailure: null,
});
const searchActiveDonorsFailure = (state, { error }) => ({
  ...state,
  searchActiveDonorsLoading: false,
  searchActiveDonorsSuccess: null,
  searchActiveDonorsFailure: error,
});

const registerDonorLoading = (state) => ({
  ...state,
  registerDonorLoading: true,
  registerDonorSuccess: null,
  registerDonorFailure: null,
});

const registerDonorSuccess = (state, { res }) => ({
  ...state,
  registerDonorLoading: false,
  registerDonorSuccess: res,
  registerDonorFailure: null,
});

const registerDonorFailure = (state, { error }) => ({
  ...state,
  registerDonorLoading: false,
  registerDonorSuccess: null,
  registerDonorFailure: error,
});

const updateDonorLoading = (state) => ({
  ...state,
  updateDonorLoading: true,
  updateDonorSuccess: null,
  updateDonorFailure: null,
});

const updateDonorSuccess = (state, { res }) => ({
  ...state,
  updateDonorLoading: false,
  updateDonorSuccess: res,
  updateDonorFailure: null,
});

const updateDonorFailure = (state, { error }) => ({
  ...state,
  updateDonorLoading: false,
  updateDonorSuccess: null,
  updateDonorFailure: error,
});

const inquiryDonorLoading = (state) => ({
  ...state,
  inquiryDonorLoading: true,
  inquiryDonorSuccess: null,
  inquiryDonorFailure: null,
});

const inquiryDonorSuccess = (state, { res }) => ({
  ...state,
  inquiryDonorLoading: false,
  inquiryDonorSuccess: res,
  inquiryDonorFailure: null,
});

const inquiryDonorError = (state, { error }) => ({
  ...state,
  inquiryDonorLoading: false,
  inquiryDonorSuccess: null,
  inquiryDonorFailure: error,
});

const getDonorsPreferencesLoading = (state) => ({
  ...state,
  lastPreferencesUpdate: +new Date(),
  getDonorsPreferencesLoading: true,
  getDonorsPreferencesSuccess: null,
  getDonorsPreferencesFailure: null,
});

const getDonorsPreferencesSuccess = (state, { res }) => ({
  ...state,
  Preferences: res,
  getDonorsPreferencesLoading: false,
  getDonorsPreferencesSuccess: res,
  getDonorsPreferencesFailure: null,
});

const getDonorsPreferencesFailure = (state, { error }) => ({
  ...state,
  getDonorsPreferencesLoading: false,
  getDonorsPreferencesSuccess: null,
  getDonorsPreferencesFailure: error,
});

const updateDonorsPreferencesLoading = (state) => ({
  ...state,
  updateDonorsPreferencesLoading: true,
  updateDonorsPreferencesSuccess: null,
  updateDonorsPreferencesFailure: null,
});

const updateDonorsPreferencesSuccess = (state, { res }) => ({
  ...state,
  Preferences: res,
  updateDonorsPreferencesLoading: false,
  updateDonorsPreferencesSuccess: true,
  updateDonorsPreferencesFailure: null,
});

const updateDonorsPreferencesFailure = (state, { error }) => ({
  ...state,
  updateDonorsPreferencesLoading: false,
  updateDonorsPreferencesSuccess: null,
  updateDonorsPreferencesFailure: error,
});

const registerGetDonorProfileLoading = (state) => ({
  ...state,
  registerGetDonorProfileLoading: true,
  registerGetDonorProfileSuccess: null,
  registerGetDonorProfileFailure: null,
});
const registerGetDonorProfileSuccess = (state, { res }) => ({
  ...state,
  registerGetDonorProfileLoading: false,
  registerGetDonorProfileSuccess: res,
  registerGetDonorProfileFailure: null,
});
const registerGetDonorProfileFailure = (state, { error }) => ({
  ...state,
  registerGetDonorProfileLoading: false,
  registerGetDonorProfileSuccess: null,
  registerGetDonorProfileFailure: error,
});

const getDonorLifetimeImpactLoading = (state) => ({
  ...state,
  getDonorLifetimeImpactLoading: true,
  getDonorLifetimeImpactSuccess: null,
  getDonorLifetimeImpactFailure: null,
});
const getDonorLifetimeImpactSuccess = (state, { res }) => ({
  ...state,
  getDonorLifetimeImpactLoading: false,
  getDonorLifetimeImpactSuccess: res?.data,
  getDonorLifetimeImpactFailure: null,
});
const getDonorLifetimeImpactFailure = (state, { error }) => ({
  ...state,
  getDonorLifetimeImpactLoading: false,
  getDonorLifetimeImpactSuccess: null,
  getDonorLifetimeImpactFailure: error,
});

const getDonorApcStatusLoading = (state) => ({
  ...state,
  getDonorApcStatusLoading: true,
  getDonorApcStatusSuccess: null,
  getDonorApcStatusFailure: null,
});
const getDonorApcStatusSuccess = (state, { res }) => ({
  ...state,
  getDonorApcStatusLoading: false,
  getDonorApcStatusSuccess: res?.data,
  getDonorApcStatusFailure: null,
});
const getDonorApcStatusFailure = (state, { error }) => ({
  ...state,
  getDonorApcStatusLoading: false,
  getDonorApcStatusSuccess: null,
  getDonorApcStatusFailure: error,
});

const getDonorReferEarnedAmountLoading = (state) => ({
  ...state,
  getDonorReferEarnedAmountLoading: true,
  getDonorReferEarnedAmountSuccess: null,
  getDonorReferEarnedAmountFailure: null
});

const getDonorReferEarnedAmountSuccess = (state, { res }) => ({
  ...state,
  getDonorReferEarnedAmountLoading: false,
  getDonorReferEarnedAmountSuccess: res,
  getDonorReferEarnedAmountFailure: null
});

const getDonorReferEarnedAmountFailure = (state, { error }) => ({
  ...state,
  getDonorReferEarnedAmountLoading: false,
  getDonorReferEarnedAmountSuccess: null,
  getDonorReferEarnedAmountFailure: error
});

const cleanDonorsState = (state) => ({
  ...state,
  donors: null,
  donorSearch: null,
  getAllDonorsSuccess: null,
  getDonorsSuccess: null,
  updateDonorSuccess: null,
  inquiryDonorSuccess: null,
  getDonorsPreferencesSuccess: null,
  updateDonorsPreferencesSuccess: null,
});

export const reducer = createReducer(INITIAL_STATE, {
  [DonorTypes.GET_ALL_DONORS_LOADING]: getAllDonorsLoading,
  [DonorTypes.GET_ALL_DONORS_SUCCESS]: getAllDonorsSuccess,
  [DonorTypes.GET_ALL_DONORS_FAILURE]: getAllDonorsFailure,

  [DonorTypes.GET_DONORS_LOADING]: getDonorsLoading,
  [DonorTypes.GET_DONORS_SUCCESS]: getDonorsSuccess,
  [DonorTypes.GET_DONORS_FAILURE]: getDonorsFailure,

  [DonorTypes.GET_DONOR_BY_SFID_LOADING]: getDonorBySfidLoading,
  [DonorTypes.GET_DONOR_BY_SFID_SUCCESS]: getDonorBySfidSuccess,
  [DonorTypes.GET_DONOR_BY_SFID_FAILURE]: getDonorBySfidFailure,

  [DonorTypes.SEARCH_FOR_DONOR_LOADING]: searchForDonorLoading,
  [DonorTypes.SEARCH_FOR_DONOR_SUCCESS]: searchForDonorSuccess,
  [DonorTypes.SEARCH_FOR_DONOR_FAILURE]: searchForDonorFailure,

  [DonorTypes.SEARCH_ACTIVE_DONORS_LOADING]: searchActiveDonorsLoading,
  [DonorTypes.SEARCH_ACTIVE_DONORS_SUCCESS]: searchActiveDonorsSuccess,
  [DonorTypes.SEARCH_ACTIVE_DONORS_FAILURE]: searchActiveDonorsFailure,

  [DonorTypes.REGISTER_DONOR_LOADING]: registerDonorLoading,
  [DonorTypes.REGISTER_DONOR_SUCCESS]: registerDonorSuccess,
  [DonorTypes.REGISTER_DONOR_FAILURE]: registerDonorFailure,

  [DonorTypes.REGISTER_GET_DONOR_PROFILE_LOADING]:
    registerGetDonorProfileLoading,
  [DonorTypes.REGISTER_GET_DONOR_PROFILE_SUCCESS]:
    registerGetDonorProfileSuccess,
  [DonorTypes.REGISTER_GET_DONOR_PROFILE_FAILURE]:
    registerGetDonorProfileFailure,

  [DonorTypes.UPDATE_DONOR_LOADING]: updateDonorLoading,
  [DonorTypes.UPDATE_DONOR_SUCCESS]: updateDonorSuccess,
  [DonorTypes.UPDATE_DONOR_FAILURE]: updateDonorFailure,

  [DonorTypes.INQUIRY_DONOR_LOADING]: inquiryDonorLoading,
  [DonorTypes.INQUIRY_DONOR_SUCCESS]: inquiryDonorSuccess,
  [DonorTypes.INQUIRY_DONOR_FAILURE]: inquiryDonorError,

  [DonorTypes.GET_DONORS_PREFERENCES_LOADING]: getDonorsPreferencesLoading,
  [DonorTypes.GET_DONORS_PREFERENCES_SUCCESS]: getDonorsPreferencesSuccess,
  [DonorTypes.GET_DONORS_PREFERENCES_FAILURE]: getDonorsPreferencesFailure,

  [DonorTypes.UPDATE_DONORS_PREFERENCES_LOADING]:
    updateDonorsPreferencesLoading,
  [DonorTypes.UPDATE_DONORS_PREFERENCES_SUCCESS]:
    updateDonorsPreferencesSuccess,
  [DonorTypes.UPDATE_DONORS_PREFERENCES_FAILURE]:
    updateDonorsPreferencesFailure,

  [DonorTypes.GET_DONOR_LIFETIME_IMPACT_LOADING]: getDonorLifetimeImpactLoading,
  [DonorTypes.GET_DONOR_LIFETIME_IMPACT_SUCCESS]: getDonorLifetimeImpactSuccess,
  [DonorTypes.GET_DONOR_LIFETIME_IMPACT_FAILURE]: getDonorLifetimeImpactFailure,

  [DonorTypes.GET_DONOR_APC_STATUS_LOADING]: getDonorApcStatusLoading,
  [DonorTypes.GET_DONOR_APC_STATUS_SUCCESS]: getDonorApcStatusSuccess,
  [DonorTypes.GET_DONOR_APC_STATUS_FAILURE]: getDonorApcStatusFailure,

  [DonorTypes.GET_DONOR_REFER_EARNED_AMOUNT_LOADING]: getDonorReferEarnedAmountLoading,
  [DonorTypes.GET_DONOR_REFER_EARNED_AMOUNT_SUCCESS]: getDonorReferEarnedAmountSuccess,
  [DonorTypes.GET_DONOR_REFER_EARNED_AMOUNT_FAILURE]: getDonorReferEarnedAmountFailure,

  [DonorTypes.CLEAN_DONORS_STATE]: cleanDonorsState,
});
